import
{
  LeaderboardContainer,
  Title,
  TableStatsContainer,
  DataHeaders,
  DataCells,
} from './PrintStatsLeaderboard.style';


import SectionContainer from '../../Containers/PrintSectionContainer/PrintSectionContainer';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Stack, Typography } from '@mui/material';
import { colors } from '../../../options/colors';

const calcCellAlignment = (length, idx) =>
{
  let textAlign = 'center';
  let paddingRight = 0;
  if (idx === 0) { textAlign = 'left' }
  if (length === 2 && idx === 1) { paddingRight = 0; }
  return { textAlign, paddingRight }
}
const transpose = (matrix) =>
{
  return matrix[0].map((col, i) => matrix.map(row => row[i]));
}

const PrintStatsLeaderboard = ({ title, data, dataHeaders, keyP }) =>
{
  let newData = transpose(data);
  return (
    <LeaderboardContainer className="leaderboard-header" sx={{
      width: "33%"
    }}>


      <Stack
        key={`${keyP}-outer`}
        className='leaderboard-outer-grid'
        direction="column"
        justifyContent="flex-start"
        alignItems="stretch"
        spacing={4}
        sx={{ padding: "10px" }}>

        <Title className='leaderboard-title' >
          {title}
        </Title>


        <Stack
          key={`${keyP}-data`}
          className='leaderboard-data'
          direction="row"
          justifyContent="space-between"

        >
          {
            newData?.map((col, colIdx) => (
              <Stack
                key={`${keyP}-data-col-${colIdx}`}
                className='leaderboard-data-col'
                direction="column"
                justifyContent="flex-start"
                alignItems="stretch"
                spacing="0"
              >


                <DataHeaders sx={{ ...calcCellAlignment(dataHeaders.length, colIdx), }} >
                  {dataHeaders[colIdx]}
                </DataHeaders>
                {
                  col.map((element, idx) =>
                  {
                    let { textAlign, paddingRight } = calcCellAlignment(col.length, colIdx);

                    return (
                      <DataCells sx={{ textAlign, paddingRight }} >
                        {element}
                      </DataCells>
                    )
                  })
                }
              </Stack>
            ))
          }
        </Stack>
      </Stack>


    </LeaderboardContainer >
  );
};

export default PrintStatsLeaderboard;
